const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

interface LogoProps {
  /** "light" for dark backgrounds (white text), "dark" for light backgrounds. */
  tone?: "light" | "dark";
  className?: string;
}

export function Logo({ tone = "dark", className = "" }: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src={`${BASE}/logo.png`}
        alt="Alea ERP"
        className="h-11 w-auto"
      />
      <span
        className={`text-xl font-extrabold tracking-tight ${
          tone === "light" ? "text-white" : "text-[#0a2d4a] dark:text-white"
        }`}
      >
        Alea ERP
      </span>
    </span>
  );
}
